import apiSlice from "./ApiSlice";
import { DispositionLevelTwoFormValues } from "src/models/DispositionLevelTwo.model";

export const dispositionLevelTwoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllDispositionLevelTwo: builder.query({
      providesTags: ["dispositionSecond", "dispositionFirst"],
      query: (body) => {
        return {
          url: "/disposition-second",
          method: "GET",
          body,
        };
      },
    }),

    // GET
    getDispositionLevelTwo: builder.query({
      providesTags: ["dispositionSecond", "dispositionFirst"],
      query: (body) => {
        return {
          url: "/disposition-second",
          method: "POST",
          body,
        };
      },
    }),

    // GET SINGLE LANGUUAGE
    getDispositionLevelTwoById: builder.query({
      providesTags: ["dispositionSecond", "dispositionFirst"],
      query: (id) => {
        return {
          url: `/disposition-second/${id}`,
          method: "GET",
        };
      },
    }),

    // GET ALL Disposition Level Two by Disposition Level One
    getAllDispositionLevelTwoByLevelOneId: builder.query({
      providesTags: ["dispositionSecond", "dispositionFirst"],
      query: (id) => {
        return {
          url: `/disposition-second/get-by-disposition-one/${id}`,
          method: "GET",
        };
      },
    }),

    // ADD
    addDispositionLevelTwo: builder.mutation({
      invalidatesTags: ["dispositionSecond", "dispositionFirst"],
      query: (body: DispositionLevelTwoFormValues) => {
        return {
          url: "/disposition-second/add",
          method: "POST",
          body,
        };
      },
    }),

    // Edit
    editDispositionLevelTwo: builder.mutation({
      invalidatesTags: ["dispositionSecond", "dispositionFirst"],
      query: ({ id, body }) => {
        return {
          url: `/disposition-second/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // DELETE
    deleteDispositionLevelTwo: builder.mutation({
      invalidatesTags: ["dispositionSecond", "dispositionFirst"],
      query: (id) => {
        return {
          url: `/disposition-second/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGetAllDispositionLevelTwoQuery,
  useGetDispositionLevelTwoQuery,
  useGetDispositionLevelTwoByIdQuery,
  useGetAllDispositionLevelTwoByLevelOneIdQuery,
  useAddDispositionLevelTwoMutation,
  useEditDispositionLevelTwoMutation,
  useDeleteDispositionLevelTwoMutation,
} = dispositionLevelTwoApi;
